import React , { useState } from "react";
import tw, { styled, css } from 'twin.macro'


type ButtonProps = {
  theme ?: 'light' | 'dark'
  children ?: React.ReactNode
}

const Button = (props : ButtonProps) => {
  const { children, theme } = props;
   return(
     <ButtonWrapper {...props}>{children}</ButtonWrapper>
   );
}


const ButtonWrapper = styled.a<ButtonProps>`
  ${tw`
    inline-block
    relative

    rounded-[6px]
    border-solid
    border-2
    text-[13px]
    leading-[16px]
    p-[18px 22px]

    font-bold
    cursor-pointer

    lg:p-[14px 18px]
    lg:text-[13px]
    lg:leading-[16px]

    md:p-[14px 18px]
    md:text-[13px]
    md:leading-[16px]

    sm:p-[14px 18px]
    sm:text-[13px]
    sm:leading-[16px]

    after:absolute
    after:w-[6px]
    after:h-[6px]
    after:hidden
    after:rounded-full
    after:top-2
    after:right-2
    after:align-top

  `}

  header &:first-of-type{
    ${tw`
      rounded-[12px 6px 6px 6px]
    `}
  }

  header &:last-of-type{
    ${tw`
      rounded-[6px 6px 12px 6px]
    `}
  }

  &.update, &.new{
    ${tw`
      after:block
    `}
  }

  &.update{
    ${(props : ButtonProps) => props.theme === 'dark' ?
      tw`
        after:bg-badge-updated-dark
    ` :
      tw`
        after:bg-badge-updated-light
      `
    }
  }

  &.new{
    ${(props : ButtonProps) => props.theme === 'dark' ?
      tw`
        after:bg-badge-new-dark
    ` :
      tw`
        after:bg-badge-new-light
      `
    }
  }





  ${(props : ButtonProps) => props.theme === 'dark' ?
    tw`
      border-livid-400
      text-livid-200
      hover:border-livid-200
      hover:text-livid-200
      active:bg-livid-50
      active:text-livid-900
      active:border-livid-50
      after:bg-badge-updated-dark
  ` :
    tw`
      border-livid-600
      text-livid-800
      hover:text-livid-800
      hover:border-livid-800
      active:text-livid-50
      active:bg-livid-900
      active:border-livid-900
      after:bg-badge-updated-light
    `
  }





  &.current{
    ${(props : ButtonProps) => props.theme === 'dark' ?
    tw`
      border-fanfes-dark-500
      bg-fanfes-dark-500
      text-livid-50
    ` :
    tw`
      border-fanfes-light-800
      bg-fanfes-light-800
      text-livid-50
    `}
  }






`
export default Button;
